<div class="tw-flex tw-flex-col">
  <form [formGroup]="statementPeriodForm">
    <!-- Statement Period Section -->
    <div
      class="tw-flex tw-flex-col tw-gap-3 tw-px-6 sm:tw-px-4 tw-py-4 tw-rounded-xl tw-bg-dt-surface-card tw-border tw-border-neutral-100"
    >
      <div class="tw-flex tw-flex-col tw-gap-2">
        <span class="tw-font-medium">{{ "fileName" | i18n }} *</span>
        <app-input
          [value]="statementPeriodForm.get('fileName').value"
          [placeholder]="'enterFileName' | i18n"
          [isRequired]="true"
          (outputValue)="onFileNameChange($event)"
        ></app-input>
      </div>

      <div class="tw-flex tw-w-full tw-flex-col tw-gap-1">
        <span class="tw-font-medium">{{ "statementPeriod" | i18n }} *</span>

        <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 sm:tw-gap-2 tw-w-full">
          <!-- From -->
          <div
            cdkOverlayOrigin
            #startOrigin="cdkOverlayOrigin"
            class="left-round-border tw-flex tw-min-h-12 tw-w-full tw-cursor-pointer tw-items-center tw-gap-2 tw-bg-dt-surface-card tw-px-5 sm:tw-px-4 tw-shadow-button"
            [ngClass]="{ 'input-error-border': showError('startDate') }"
            data-testid="statement-period-from"
            (click)="togglePicker('start')"
          >
            <span class="tw-font-medium">{{ "from" | i18n }}</span>
            <span
              class="tw-flex-grow tw-whitespace-nowrap tw-text-neutral-800"
              [ngClass]="{ 'tw-opacity-60': !startDateText }"
            >
              {{ startDateText || "YYYY-MM-DD" }}
            </span>
            <icon [name]="'calendar'" [size]="5" [currentColor]="'primary'"></icon>
          </div>

          <!-- To -->
          <div
            cdkOverlayOrigin
            #endOrigin="cdkOverlayOrigin"
            class="right-round-border tw-flex tw-min-h-12 tw-w-full tw-cursor-pointer tw-items-center tw-gap-2 tw-bg-dt-surface-card tw-px-5 tw-shadow-button"
            [ngClass]="{ 'input-error-border': showError('endDate') }"
            data-testid="statement-period-to"
            (click)="togglePicker('end')"
          >
            <span class="tw-font-medium">{{ "to" | i18n }}</span>
            <span
              class="tw-flex-grow tw-whitespace-nowrap tw-text-neutral-800"
              [ngClass]="{ 'tw-opacity-60': !endDateText }"
            >
              {{ endDateText || "YYYY-MM-DD" }}
            </span>
            <icon [name]="'calendar'" [size]="5" [currentColor]="'primary'"></icon>
          </div>
        </div>
      </div>

      <!-- Calendars render in a CDK overlay so they escape the modal-body's overflow clipping -->
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="startOrigin"
        [cdkConnectedOverlayOpen]="showStartPicker"
        [cdkConnectedOverlayPositions]="overlayPositions"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        (backdropClick)="closePickers()"
        (detach)="closePickers()"
      >
        <app-calendar
          class="calendar-reset"
          [pickerType]="'start'"
          [dateRange]="calendarDateRange"
          [originalDateRange]="originalDateRange"
          [timeDirectionOptions]="[AGO]"
          [currentDateFilter]="startDateFilter"
          (dateChangeEvent)="onCalendarRangeChange($event)"
          (cancelEvent)="closePickers()"
        ></app-calendar>
      </ng-template>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="endOrigin"
        [cdkConnectedOverlayOpen]="showEndPicker"
        [cdkConnectedOverlayPositions]="overlayPositions"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        (backdropClick)="closePickers()"
        (detach)="closePickers()"
      >
        <app-calendar
          class="calendar-reset"
          [pickerType]="'end'"
          [dateRange]="calendarDateRange"
          [originalDateRange]="originalDateRange"
          [timeDirectionOptions]="[AGO]"
          [currentDateFilter]="endDateFilter"
          (dateChangeEvent)="onCalendarRangeChange($event)"
          (cancelEvent)="closePickers()"
        ></app-calendar>
      </ng-template>
    </div>
  </form>
</div>
